




import SvgIcon from '@/icons/SvgIcon.vue';
import {Component, Prop, Vue} from 'vue-property-decorator';
import icons, {SvgSymbolData} from '../icons';

@Component({components: {SvgIcon}})
export default class Icon extends Vue {
    @Prop({type: String, required: true})
    public readonly dataIcon: keyof typeof icons;

    protected symbolData(): SvgSymbolData {
        return icons[this.dataIcon] as SvgSymbolData;
    }
}
